import React, { useEffect, useState } from "react";
import { Container, Col, Row, Card } from "react-bootstrap";
import { isMobile } from "react-device-detect";
import { useParams, useLocation, useNavigate, Link } from "react-router-dom";
import SplitNumber from "../../components/SplitNumber";
import ApiBasket from "../../../core/api/api.basket";
import ModalCanclepersonItem from "./Component/ModalCanclepersonItem";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import SkeletonOrderDetail from "../../components/SkeletonComponent/SkeletonOrderDetail";
import CardOrderDetail from "./Component/CardOrderDetail";
import { ToastContainer, toast } from "react-toastify";
import _ from "lodash";
import "react-toastify/dist/ReactToastify.css";
import { IconArrowRight } from "../../../assets/icons";

function OrderDetail() {
  const { id } = useParams();
  let location = useLocation();
  let navigate = useNavigate();
  const [basket, setbasket] = useState({
    basketItems: [],
  });
  const [showModalCancle, setShowModalCancle] = useState(false);
  const [itemForCancleModal, setItemForCancleModal] = useState({});
  const [count, setCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [isImageLoad, setIsImageLoad] = useState(false);
  useEffect(() => {
    (async () => {
      try {
        let paramId = 0;
        if (id && _.toInteger(id) > 0) paramId = _.toInteger(id);
        if (
          paramId == 0 &&
          !_.isEmpty(location.state) &&
          _.isNumber(location.state?.basketId)
        )
          paramId = _.toInteger(location.state.basketId);
        if (paramId > 0) {
          // دریافت سفارش
          const result = await ApiBasket.getBasketById({ basketId: paramId });

          if (result.succeeded == true) {
            setbasket(result.data, "result result ");
            setIsLoading(false);
          } else {
            // نمایش پیغام
            // toast.configure();
            toast.warn(
              "سفارش مد نظر پیدا نشد لطفا به صفحه سفارشات برگشته و مجددا تلاش نمایید",
              { position: "top-right" }
            );
          }
        }
        // else {
        //     if (!_.isEmpty(location.state) && !_.isEmpty(location?.state?.statusList) && !_.isEmpty(location?.state?.title))
        //     history.push('/orderList', { statusList: location?.state?.statusList, title: location?.state?.title });
        //     else
        //     history.push('/order', { prevPath: location.pathname });
        // }
      } catch (error) {
      } finally {
      }
    })();
    return () => {};
  }, [location, count]);

  const handleModalCancle = (item) => {
    setShowModalCancle(!showModalCancle);
    setItemForCancleModal(item);
  };
  const callBackForModalCancle = () => {
    setShowModalCancle(!showModalCancle);
    setCount((c) => c + 1);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      {/* <ToastContainer></ToastContainer> */}
      <SkeletonTheme baseColor="#cecdcd" highlightColor="#e2dfdf">
        {showModalCancle && (
          <ModalCanclepersonItem
            item={itemForCancleModal}
            basket={basket}
            callBack={callBackForModalCancle}
          />
        )}

        <Container
          fluid
          className={
            !isMobile
              ? "main-content bg-light-3 min-height-page"
              : "main-content"
          }
        >
          {!isMobile ? (
            <Container>
              <Row className="pt-3 pb-2 fs-085">
                <Col xs={12} className="px-0">
                  <Link to="/" className="text-muted">
                    {" "}
                    صفحه اصلی{" "}
                  </Link>{" "}
                  /{" "}
                  <Link to="/order" className="text-muted">
                    {" "}
                    سفارش ها{" "}
                  </Link>{" "}
                  /{" "}
                  <Link
                    className="text-muted"
                    to={{
                      pathname: "/order/orderList",
                      state: {
                        statusList: location?.state?.statusList,
                        title: location?.state?.title,
                      },
                    }}
                  >
                    {location?.state?.title}
                  </Link>{" "}
                  <Link
                    className="text-muted"
                    to={{
                      pathname:
                        "/order/orderDetail/" + location?.state?.basketId,
                      state: {
                        statusList: location?.state?.statusList,
                        title: location?.state?.title,
                        basketId: location?.state?.basketId,
                      },
                    }}
                  >
                    {" "}
                    جزئیات سفارش
                  </Link>
                  {/* <Link to="/order/orderList" className="text-muted"> سفارش های در حال پردازش </Link>{" "} / {" "}
                                        <Link to="/order/orderDetail" className="text-muted fw-bold"> جزئیات سفارش </Link> */}
                </Col>
              </Row>
            </Container>
          ) : (
            <Col xs={12} className="my-auto pt-4 pb-2 large-svg">
              <Link
                className="text-right text-dark"
                to={{
                  pathname: "/order/orderList",
                  state: {
                    type: location?.state?.type,
                    title: location?.state?.title,
                  },
                }}
              >
                <IconArrowRight fillColor="#000" />
                <h3 className="fs-102 my-auto d-inline-block"> جزئیات سفارش</h3>
              </Link>
            </Col>
          )}
          <Container className="px-0">
            <Row>
              <Col xs={12} className="pt-1 mt-1  transaction-box">
                <Row className="px-0">
                  <Col xs={12} lg={5}>
                    <Card
                      className="w-100 rounded-4 mb-2"
                      style={{ lineHeight: "27px" }}
                    >
                      <Card.Body>
                        <Row>
                          <Col xs={6} className="pe-0 text-muted">
                            {" "}
                            کد سفارش{" "}
                          </Col>
                          <Col xs={6} className="text-end text-dark ">
                            {isLoading ? <Skeleton /> : basket?.id}
                          </Col>

                          <Col xs={6} className="pe-0 text-muted">
                            {" "}
                            تاریخ اخرین تغییر{" "}
                          </Col>
                          <Col xs={6} className="text-end text-dark ">
                            {isLoading ? <Skeleton /> : basket?.lastModified}
                          </Col>
                        </Row>
                        <Row className="pt-3 mt-3 border-dashed-top">
                          <Col xs={6} className="pe-0 text-muted">
                            {" "}
                            تعداد ایتم ها{" "}
                          </Col>
                          <Col xs={6} className="text-end text-dark ">
                            {isLoading ? (
                              <Skeleton />
                            ) : !_.isEmpty(basket) &&
                              !_.isEmpty(basket?.basketItems) &&
                              basket?.basketItems.length > 0 ? (
                              basket?.basketItems?.length
                            ) : (
                              "0"
                            )}
                          </Col>

                          <Col xs={6} className="pe-0 text-muted">
                            {" "}
                            مبلغ کل{" "}
                          </Col>
                          <Col xs={6} className="text-end text-dark  ">
                            {isLoading ? (
                              <Skeleton />
                            ) : (
                              <span>
                                {" "}
                                <span className="text-decoration-line-throught-rotate border-secondary">
                                  {" "}
                                  {isLoading ? (
                                    <Skeleton />
                                  ) : (
                                    <SplitNumber
                                      number={basket?.originalPrice}
                                    ></SplitNumber>
                                  )}
                                </span>{" "}
                                تومان{" "}
                              </span>
                            )}
                          </Col>

                          <Col xs={6} className="pe-0 text-muted">
                            {" "}
                            تخفیف{" "}
                          </Col>
                          <Col xs={6} className="text-end text-danger fw-bold">
                            {" "}
                            {isLoading ? (
                              <Skeleton />
                            ) : (
                              <span>
                                {" "}
                                <SplitNumber
                                  number={basket?.originalPrice - basket?.price}
                                ></SplitNumber>{" "}
                                <span className="fs-085">تومان</span>{" "}
                              </span>
                            )}{" "}
                          </Col>

                          <Col xs={6} className="pe-0 text-muted">
                            {" "}
                            مبلغ کل پرداخت شده{" "}
                          </Col>
                          <Col xs={6} className="text-end  text-dark fw-bold">
                            {" "}
                            {isLoading ? (
                              <Skeleton />
                            ) : (
                              <span>
                                {" "}
                                <SplitNumber
                                  number={basket?.price}
                                ></SplitNumber>{" "}
                                تومان{" "}
                              </span>
                            )}
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                  </Col>

                  {isLoading ? (
                    <SkeletonOrderDetail />
                  ) : (
                    <Col xs={12} lg={7} className="pr-lg-0">
                      {/* repeat start */}

                      {basket?.basketItems?.map((item, index) => (
                        <CardOrderDetail
                          item={item}
                          index={index}
                          key={index}
                          basket={basket}
                          callBack={handleModalCancle}
                        />
                      ))}

                      {/* repeat end */}
                    </Col>
                  )}
                </Row>
              </Col>
            </Row>
          </Container>
        </Container>
      </SkeletonTheme>
    </>
  );
}
export default OrderDetail;
